import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.ChannelInfoView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'channel-info'
  name: 'channel-info-table'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  chartClass: 'fb-info-table'

  initialize: (@options = {}) ->
    @columns = ['Metrica', 'valor' ]
    @labels = {followers: "Followers", new_followers: "New Followers", profile_visits: "Visitas al perfil", tweets: "Tweets", mentions: "Mentions", fans: "Fans totales", new_fans: "Fans nuevos", dislikes: "Dislikes", fans_balance: "Fans netos", fans_balance_month_grow: "Tasa de crecimiento de fans netos en base al mes anterior"}

  render: ->
    @specific_settings ||= {}

    @specific_settings.benchmark = true
    @$el.html(@template(self: this))
    @bindChartsReady(1)
    @_getTable().addClass('processing')
    query = @labelsQuery(@labelFilter(), @labelsStructure())
    fb_page = @getTemplateOptions().page

    @setBenchmarkSettingsIfNecessary(query)
    $.post(@options.chartApi.channel_info + @getTemplateOptions().network, _.extend({page: fb_page}, query, @getExtraQuery()), (response) =>
      tableData = { columns: @columns, data: [], types: ['string', 'string'], options: {} }
      for k,v of response
        tableData.data.push([@labels[k] || k,v])
      @_getTable().html(new Monitoring.Reports.Executive.TableView(response: tableData).render().el)
    )
    return this

  _getTable: ->
    @$el.find(".#{@chartClass}")
